<template>
  <InvoiceParameterDefaultModal
    :title="title"
    width="400"
    :show="show"
    @close="close">
    <template slot="body">
      <div
        class="d-flex flex-row gap-h-10">
        <v-icon color="success">far fa-check-circle</v-icon>
        <TextBase>A regra foi {{label}} com sucesso.</TextBase>
      </div>
    </template>
    <template slot="actions">
      <div
        class="d-flex justify-center gap-h-20 fill-width">
        <v-btn
          class="action-button-modal"
          color="primary"
          @click="close">
          Ok
        </v-btn>
      </div>
    </template>
  </InvoiceParameterDefaultModal>
</template>
<script>
import InvoiceParameterDefaultModal from './InvoiceParameterDefaultModal.vue';
import InvoiceParameterText from '../components/InvoiceParameterText.vue';
import { mapMutations } from 'vuex';
export default {
  name: "RuleLinkSuccessModal",
  components: {
    InvoiceParameterDefaultModal,
    TextBase: InvoiceParameterText,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapMutations({
      setShowRuleUnlinkSuccessModal: 'invoice-parameter/setShowRuleUnlinkSuccessModal',
      setShowRuleLinkSuccessModal: 'invoice-parameter/setShowRuleLinkSuccessModal',
    }),
    close() {
      this.setShowRuleUnlinkSuccessModal(false);
      this.setShowRuleLinkSuccessModal(false);
    },
  }
}
</script>
<style lang="scss">
@import "@/shared/styles/invoiceParameters/default.scss";
</style>